import * as Sentry from "@sentry/vue";

/**
 * Calculate a high-contrast text color (black or white) for a given background color.
 * @param {string} colorValue - A hex color string (e.g., '#FFC400' or 'FFC400').
 * @returns {string} '#000' for light backgrounds, '#fff' for dark backgrounds.
 */
export function getHighContrastTextColor(colorValue) {
  if (!colorValue) return '#000';

  let r, g, b;

  try {
    const h = colorValue.replace('#', '');
    r = parseInt(h.substring(0, 2), 16);
    g = parseInt(h.substring(2, 4), 16);
    b = parseInt(h.substring(4, 6), 16);
  } catch (e) {
    Sentry.captureException(e, {
      tags: { errorType: 'hex_color_parse_error' },
      extra: { colorValue }
    });
    return '#000';
  }

  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 180 ? '#000' : '#fff';
}

// Sky condition colors - JavaScript is the source of truth
export const SKY_COLORS = {
  clear: '#FFC400',
  partly_cloudy: '#E0E0E0',
  cloudy: '#9E9E9E',
  rain: '#2196F3',
  scattered_rain: '#40C4FF',
  sleet: '#7B68EE',
  scattered_sleet: '#9B88FF',
  hail: '#8B4789',
  scattered_hail: '#B565B3',
  snow: '#673AB7',
  scattered_snow: '#9575CD',
};

export const windColors = [
  '#9D9D9D', // wind_force_0
  '#80CBC4', // wind_force_1
  '#81C784', // wind_force_2
  '#9CCC65', // wind_force_3
  '#42A047', // wind_force_4
  '#FBC02D', // wind_force_5
  '#F78C1E', // wind_force_6
  '#F1592B', // wind_force_7
  '#EF4438', // wind_force_8
  '#c62828', // wind_force_9
];
